export default __webpack_public_path__ + "img/dgyQNagm.c83ccfc5.svg";